import { useCallback, useEffect, useState } from "react";
import { isApiOfflineError } from "@/core/inventory/inventory-errors";
import { iscRequest } from "@/core/inventory/isc-client";

const RECHECK_MS = 60_000;

/** Sonde l'API ISC et expose un état offline global (réseau / service arrêté). */
export function useIscOffline(enabled: boolean) {
  const [offline, setOffline] = useState(false);
  const [checking, setChecking] = useState(false);

  const recheck = useCallback(async () => {
    if (!enabled) return;
    setChecking(true);
    try {
      await iscRequest<{ id?: string }>("/tenant");
      setOffline(false);
    } catch (err) {
      setOffline(isApiOfflineError(err));
    } finally {
      setChecking(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setOffline(false);
      return undefined;
    }

    void recheck();
    const interval = window.setInterval(() => void recheck(), RECHECK_MS);
    const onFocus = () => void recheck();
    const onRecheck = () => void recheck();
    window.addEventListener("focus", onFocus);
    window.addEventListener("hospitol:isc-recheck", onRecheck);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("hospitol:isc-recheck", onRecheck);
    };
  }, [enabled, recheck]);

  return { offline, checking, recheck };
}
